import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-inventory-management';

export default function Example() {
  return (
    <>
      <Head>
        <title>How to Management Your eBay Inventory Like a Pro</title>
        <meta
          name='description'
          content='Every seller knows that to be effective in running your business, you need to have a good grasp of how to manage your inventory as efficiently as possible. This avoids incurring additional costs, acquiring surplus inventory, and more. Find out what you need to know to nail your inventory management like a pro!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-inventory-management' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-inventory-management' />
        <meta property='og:title' content='How to Management Your eBay Inventory Like a Pro' />
        <meta
          property='og:description'
          content='Every seller knows that to be effective in running your business, you need to have a good grasp of how to manage your inventory as efficiently as possible. This avoids incurring additional costs, acquiring surplus inventory, and more. Find out what you need to know to nail your inventory management like a pro!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-23T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-23T00:00:00-00:00' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
